<template>
  <div>
    <el-dialog
      :model-value="visible"
      :title="lang('account.remove.title2')"
      :before-close="handleCancel"
      :width="400"
    >
      {{ lang('account.remove.content7', [days]) }}
      <template #footer>
        <el-button type="danger" @click="handleConfirmDelete">
          {{ lang('account.remove.removeText2') }}
        </el-button>
        <el-button type="primary" @click="handleCancel">
          {{ lang('account.remove.considerText') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElDialog, ElButton, ElMessage } from 'element-plus'
import { defineComponent } from 'vue'
import { $t as lang } from '@/Tool'
import api from '@/services'

export default defineComponent({
  props: ['visible', 'days'],
  components: { ElDialog, ElButton },
  setup(props, { emit }) {
    async function handleConfirmDelete() {
      const { success } = await api.Scrm_sys_api.userDetect.submitDetect({})
      if (success) {
        emit('success')
        ElMessage.success('注销账户申请提交成功')
      } else {
        ElMessage.success('注销账户申请提交失败，请重试~')
      }
    }

    function handleCancel() {
      emit('close')
    }

    return {
      lang,
      handleCancel,
      handleConfirmDelete,
    }
  },
})
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  border-radius: 8px;
}
:deep(.el-dialog__header) {
  text-align: center;
  padding-top: 49px;
}
:deep(.el-dialog__title) {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
:deep(.el-dialog__body) {
  font-size: 14px;
  line-height: 27px;
  color: #000;
  padding: 20px 49px;
}
:deep(.el-dialog__footer) {
  text-align: center;
  .el-button {
    width: 110px;
    height: 32px;
    border-radius: 4px;
    font-size: 12px;
    &--danger {
      background-color: #d61818;
    }
  }
}
</style>
